export default "__VITE_ASSET__6z_kHU9l__"